import { render, staticRenderFns } from "./AdminGroups.vue?vue&type=template&id=095d53a3&scoped=true"
import script from "./AdminGroups.vue?vue&type=script&lang=ts"
export * from "./AdminGroups.vue?vue&type=script&lang=ts"
import style0 from "./AdminGroups.vue?vue&type=style&index=0&id=095d53a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095d53a3",
  null
  
)

export default component.exports